import { render, staticRenderFns } from "./top-chat-msg.vue?vue&type=template&id=eb5b322c&scoped=true&"
import script from "./top-chat-msg.vue?vue&type=script&lang=js&"
export * from "./top-chat-msg.vue?vue&type=script&lang=js&"
import style0 from "./top-chat-msg.vue?vue&type=style&index=0&id=eb5b322c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5b322c",
  null
  
)

export default component.exports